import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../../components/Link';
import { formatNumber, getDecimals } from '../../service/market';
import TableRowSkeleton from './TableRowSkeleton';
import css from '../../styles/table/tablerow';
import { icons } from '../../config';


// @TODO: Combine methods, i.e. renderLast and renderChange
class TableRow extends Component {
    static propTypes = {
        subtitle: PropTypes.string,
        image: PropTypes.string,
        symbol: PropTypes.string,
        ready: PropTypes.bool,
        LONG_NAME: PropTypes.string,
        SECURITYNAME: PropTypes.string,
        LAST: PropTypes.number,
        LASTNZ: PropTypes.number,
        CHANGE: PropTypes.number,
        CHANGE_PCT: PropTypes.number,

        breakpoint: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = ({ sign: css.neutral });

        this._setSign = p => {
            const { CHANGE, CHANGE_PCT } = p;

            const change = CHANGE || CHANGE_PCT;

            let sign;

            if (!change || change === 0) {
                sign = css.neutral;
            } else {
                sign = change > 0 ? css.positive : css.negative;
            }

            this.setState({ sign });
        };
    }

    componentDidMount() {
        this._setSign(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this._setSign(nextProps);
    }

    renderImage() {
        const { image } = this.props;

        if (!image || !icons[image]) return null;

        const backgroundPosition = { backgroundPosition: icons[image] };

        return (
            <td className={css.image}>
                <div className={css.sprite} style={backgroundPosition} data-sprite="true" />
            </td>
        );
    }

    renderName() {
        // @TODO: Fallback for names
        const { symbol, LONG_NAME, SECURITYNAME } = this.props;

        let link;
        if (symbol) {
            link = `/instrument/${encodeURIComponent(this.props.symbol).toUpperCase()}`;
        }

        return (
            <td className={css.alignLeft}>
                <Link
                    className={css.hiddenLink}
                    to={link}
                >
                    <span className={css.name}>
                        {LONG_NAME || SECURITYNAME}
                    </span>
                    <span>{this.props.subtitle}</span>
                </Link>
            </td>
        );
    }

    renderLast() {
        const { LAST, LASTNZ } = this.props;

        const decimals = getDecimals(LAST || LASTNZ);

        return <td>{formatNumber(LAST || LASTNZ, decimals)}</td>;
    }

    renderChange() {
        if (this.props.breakpoint) { return null; }

        const { CHANGE } = this.props;

        const decimals = getDecimals(CHANGE);

        return (
            <td className={this.state.sign}>
                {formatNumber(CHANGE, decimals)}
            </td>
        );
    }

    renderChangePct() {
        return (
            <td className={this.state.sign}>
                {formatNumber(this.props.CHANGE_PCT, 2, true)}
            </td>
        );
    }

    render() {
        if (!this.props.ready) {
            return <TableRowSkeleton />;
        }

        return (
            <tr className={css.tableRow}>
                {this.renderImage()}
                {this.renderName()}
                {this.renderLast()}
                {this.renderChange()}
                {this.renderChangePct()}
            </tr>
        );
    }
}

export default TableRow;



/** WEBPACK FOOTER **
 ** /src/shared/components/table/TableRow.js
 **/